import styled from "styled-components";

const PageTitle = styled.div`
    font-weight: bold;
    font-size: 20px;
    text-align: left;

    margin-top: 1em;
    margin-bottom: 1em;
    user-select:none;
    cursor: default;
`

export default PageTitle